//import { DOMParser } from 'xmldom';
import { DOMParser } from '@xmldom/xmldom';
import { AppraisalDocument } from '../models/appraisalDocument';
import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';
import { readFile, setDirHandles } from './fileHelpers';
import { setReportName, setStateLoaded } from '../store/store';


export var xmlDoc = null;

export function loadAppraisalData(xmlData) {
	xmlDoc = new DOMParser().parseFromString(xmlData, "application/xml");
	const nsmgr = x.createNamespaceResolver(xmlDoc);
	//setNS(nsmgr);
	x.initHelpers();
	var ad = new AppraisalDocument(xmlDoc);
	let docType = ad.GetDocumentType();
	global.ptr.init(ad);
	//console.log(ad);
}

export async function loadAppraisal(handle) {
	setStateLoaded(false);
	let filename = handle.name;
	let data = await readFile(handle);
	if (!data) {
		global.ptr.errors.push("There was and error loading XML file");
		return false;
	}

	if (!data.includes("<MESSAGE ")) {
		global.ptr.errors.push("File is not a MISMO Appraisal XML");
		return false;
	}

	loadAppraisalData(data);
	let docType = global.ptr.documentType;
	if (docType !== "AppraisalReport") {
		global.ptr.errors.push("File is not an Appraisal Report");
		let msg = "This program is not currently configured to handle a " + h.toEnumText(docType);
		global.ptr.errors.push(msg);
		return false;
	}

	setReportName(filename);
	setStateLoaded(true);
	console.log("report loaded: ", filename)
	return true;
}
